import { createContext, useContext } from "react";
import FormRequest from "../classes/FormRequest";

export const defaultFormRequestValue = new FormRequest({})

const formRequestContext = createContext(defaultFormRequestValue)
export default formRequestContext

export const useFormRquestContext = () => {
    const [formReqData1, setFormReqData] = useContext(formRequestContext)
    const formReqData = new FormRequest(formReqData1)
    return { formReqData, setFormReqData }
}